<template>
  <div v-if="imageData[0]" class="atom-image-switch">
    <button
      v-if="image360Data && hasValid360"
      type="button"
      class="atom-image-switch__image-flag"
      :class="{ 'is-active': image360ModeActive }"
      @click="switch360Mode()"
    >
      360°
    </button>
    <button
      v-for="image, index in imageData"
      :key="index"
      type="button"
      class="atom-image-switch__image-flag"
      :class="{ 'is-active': activeImage === index && !image360ModeActive }"
      @click="setActiveImage(index)"
    >
      <AtomImage
        v-if="image"
        :data="image"
        :is-strapi="true"
        behaviour="contain"
      />
    </button>
  </div>
</template>

<script setup>
defineProps({
    hasValid360: {
        type: Boolean,
        default: false,
    },
});
/*
  Emit active image data
*/
const emit = defineEmits(['active-image', 'set-image-360-mode']);

/*
  Inject product
*/
const product = inject('product');

/*
  Get images
*/
const teaserImage = computed(() => product?.teaser_image);
const images = computed(() => product?.images);

/*
  Merge images
*/
const imageData = computed(() => {
    if (images.value) {
        const slicedImages = images.value.slice(0, 5);
        return [teaserImage.value, ...slicedImages];
    }

    return [teaserImage.value];
});

/*
  Data 360°
*/
const image360Data = computed(() => product?.image360);
const image360ModeActive = ref(false);
const switch360Mode = (forceFalse = false) => {
    image360ModeActive.value = forceFalse ? false : !image360ModeActive.value;
    emit('set-image-360-mode', image360ModeActive.value);
};

/*
  Set active image index
*/
const activeImage = ref(0);
const setActiveImage = (index) => {
    activeImage.value = index;
    switch360Mode(true);
};

/* Initial emit */
emit('active-image', imageData.value[0]);
watch(activeImage, (value) => {
    emit('active-image', imageData.value[value]);
});

</script>

<style lang="scss">
.atom-image-switch {
    display: flex;

    .atom-image-switch__image-flag {
        @include typo-font('regular');

        display: flex;
        width: 47px;
        height: 47px;
        align-items: center;
        justify-content: center;
        padding: 2px;
        border: 2px solid $C_WHITE;
        border-radius: 6px;
        margin-right: 10px;
        background-color: $C_WHITE;
        color: $C_GREEN_DARK;
        transition: border 0.2s ease-in-out;

        .atom-image {
            height: 100%;

            img {
                max-height: 100%;
                object-fit: contain;
            }
        }

        &.is-active {
            border: 2px solid $C_PRIMARY;
        }
    }

    @include mobile {
        margin-bottom: 20px;
    }
}

</style>
